import { useLang } from '../context/LanguageContext';
import { useNewsData } from '../context/NewsDataContext';
import './EditionLiveBanner.css';

export default function EditionLiveBanner() {
  const { t } = useLang();
  const { homeFeed } = useNewsData();

  if (!homeFeed.editionLive) return null;

  return (
    <div className="edition-live" data-sub-free>
      <div className="edition-live__inner">
        <span className="edition-live__pulse" aria-hidden />
        <p className="edition-live__text">{t.editionLiveTitle}</p>
        <a href="#paper" className="edition-live__cta">
          {t.editionLiveCta} →
        </a>
      </div>
    </div>
  );
}
